<template>
<div>
  <HouseLayout @nodeClick="nodeClick">
    <el-tabs type="border-card" v-model="card_index">
      <el-tab-pane label="操作主页" name="CustomerSaleMain">
<!--        <CustomerSaleMain v-if="card_index==='CustomerSaleMain'" />-->
        <div v-if="card_index==='CustomerSaleMain'">
          <transition name="slide-fade" mode="out-in">
            <KeepAlive>
              <comment v-bind:is="componentId" :ref="componentId" :houseId="mainObj.house_id" :customerOldId="mainObj.now_customer_id" :customerNewId="mainObj.new_customer_id" />
            </KeepAlive>
          </transition>
        </div>

      </el-tab-pane>
      <el-tab-pane label="发起流程" name="CustomerSaleList">
        <CustomerSaleList v-if="card_index==='CustomerSaleList'" />
      </el-tab-pane>
    </el-tabs>
  </HouseLayout>
</div>
</template>

<script>
import HouseLayout from "../../Common/HouseLayout";
import UploadFileFJ from "./UploadFileFJ";
import CustomerSaleMain from "./CustomerSaleMain";
import CustomerSaleChange from "./CustomerSaleChange";
import CustomerSaleHistory from "./CustomerSaleHistory";
import SaleCarryOver from "./components/SaleCarryOver";
import CustomerSaleList from "./CustomerSaleList";

export default {
  name: "CustomerSale",
  components: {
    CustomerSaleList,
    CustomerSaleHistory, CustomerSaleChange, HouseLayout,UploadFileFJ,CustomerSaleMain,SaleCarryOver},
  provide(){
    return{
      commonObj:this.commonObj,
      setComponentId:this.setComponentId,
      componentId:this.componentId,
      mainObj:this.mainObj,
      onEventHandel:this.onEventHandel
    }
  },
  data(){
    return {
      home_id:0,
      form:{},
      commonObj:{
        type:1,
        house_id:"",
        id:""
      },
      mainObj:{
        project_id:"",
        house_id:"",
        house_name:"",
        now_customer_id:"",
        new_customer_id:"",
        sale_type:""
      },
      comment_list:['CustomerSaleMain','CustomerSaleChange','CustomerSaleHistory','SaleCarryOver'],
      componentId:"CustomerSaleMain",
      tableData:[],
      card_index:"CustomerSaleMain"
    }
  },
  watch:{

  },
  methods:{
    nodeClick(data){
      const that=this;
      if(data.tree[data.tree.length-1].type==='room'){
        that.setComponentId("CustomerSaleMain");
        that.commonObj.id=undefined;
        that.commonObj.house_id=data.tree[data.tree.length-1].id;
      }
      that.mainObj.project_id = data.tree[0].pindex_id;
      that.mainObj.house_name = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      if (data.tree[data.tree.length - 1].type === "room") {
        that.mainObj.house_id = data.tree[data.tree.length - 1].id;
      }else {
        that.mainObj.house_id = "";
      }
    },
    UploadFileFJSuccess(list){
      this.form.appendix=list;
    },
    setComponentId(componentId){
      this.componentId=componentId;
    },
    onEventHandel(model,type){
      const that=this;
      switch (model) {
        case 'SaleCarryOverMain':
          (type==='hide'&&this.setComponentId('CustomerSaleMain'));
          that.now_customer_id="";
          that.new_customer_id="";
          break;
        default:break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.col{
  display: flex;
  flex-direction: column;
}
.row{
  display: flex;
  flex-direction: row;
}
.descriptions-label-class{
  width: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/CustomerSale.vue